import { hasSubscription } from '@web/guards/Subscription';
import { App } from '@web/query/App';
import { useMetadata } from '@web/query/Customer/useMetadata';
import React from 'react';

interface CommonProps {
  children: React.ReactNode;
}

function HasValidSubscription({ children }: CommonProps) {
  const { data: subscriptionData } = App.useSubscriptions();

  const hasValidSubscription = React.useMemo(() => {
    return subscriptionData ? hasSubscription(subscriptionData) : false;
  }, [subscriptionData]);

  // Only fetch metadata when the user has a valid subscription — no need to call the API otherwise
  const { data: metadataData } = useMetadata({ enabled: hasValidSubscription });

  // For a legacy customer this will be undefined.
  const hasNotAcceptedTerms = metadataData?.metadata?.termsAcceptedAt === null;

  if (!hasValidSubscription || hasNotAcceptedTerms) {
    return null;
  }

  return children;
}

export { HasValidSubscription };
